import { render, staticRenderFns } from "./UserPasswordResetDialog.vue?vue&type=template&id=73522d73&scoped=true"
import script from "./UserPasswordResetDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserPasswordResetDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73522d73",
  null
  
)

export default component.exports